<template>
  <div class="rss-feed-block block-container">
    <div class="container-fluid">
        <component v-bind:is=model.headingTag v-if="model.heading" class="h2 text-center">
            <a v-if="model.anchor" :id="model.anchor" />{{ model.heading }}</component>
        <div class="d-flex flex-wrap">
            <div v-for="item in model.items" :key="item.id" class="col-lg-4">
              <rss-feed-item 
                :heading="item.heading"
                :description="item.description"
                :published="item.published"
                :url="item.url"
              />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import RssFeedItem from './rss-feed-item.vue';
  export default {
    
    components: {
      'rss-feed-item': RssFeedItem,
    },
    props: {
      model: {
        type: Object,
        required: true
      }
    }
  }
</script>